import { useParams } from "react-router-dom";
import { Page } from "../Components/page/Page";
import { STATUS_COLOR, usePurchase } from "../lib/tdn-purchase";
import { Labelled } from "../Components";
import { dateFromPython } from "../util";
import { TwinPersona } from "../Components/TwinPersona";
import Title from "../Components/page/Title";
import { useTreasuryClient } from "../lib/client";
import { useBalance } from "../lib/balance";

export default function Purchase() {
  const { id } = useParams();
  const treasury = useTreasuryClient()
  const { data: purchase } = usePurchase(id);
  const { data: dq } = useBalance(purchase?.dq);

  if (!purchase) return <Page></Page>

  return <Page>
    <div className="flex w-full justify-center">
      <div className="flex flex-col md:w-1/3">

        <Title>PURCHASE (<span className="lowercase" title={id}>{id.slice(0, 8)}</span>)</Title>
        <div className="flex flex-col gap-4">
          <Labelled label="Created">{dateFromPython(purchase.createdAt)}</Labelled>
          <Labelled label="Updated">{dateFromPython(purchase.updatedAt)}</Labelled>
          <Labelled label="Destination">
            <a href={`/profile/${encodeURIComponent(purchase.destination)}`}
              className="break-all" >
              <TwinPersona twinUrl={purchase.destination} />
            </a>
          </Labelled>
          <Labelled label={`Paid amount (${purchase.paidValueUnits})`}>
            {Number(purchase.paidValue).toFixed(2)}
          </Labelled>
          <Labelled label={`Sent amount (${treasury.tdnMoniker})`}>
            {(purchase.paidValue*treasury.tdnPurchasePrice).toFixed(dq?.displayPrecision)} ({purchase?.files?.length || 0} files)
            {purchase.files && <ul className="ml-2">
              {purchase.files.map(h => <li key={h}>{h.slice(0, 8)}</li>)}
            </ul>}
          </Labelled>

          <Labelled label="Status">
            <span className={STATUS_COLOR[purchase.status]}>{purchase.status.toUpperCase()}</span>
          </Labelled>

          <Labelled label="Reason">{purchase.statusReason || "N/A"}</Labelled>

          <Labelled label="Payment receipt">{purchase.paymentReceipt}</Labelled>
        </div>
      </div>
    </div>
  </Page>
}
